/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 14th 2022, 5:34:45 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Typography from "@mui/material/Typography";
import { DatasetReference } from "lib/schemas";
import { DropDownFormInput } from "ui-widgets/forms";
import { InputHelpDialogWrapper } from "ui-widgets";

export const DatasetReferenceRetreivalSettings = ({
  referencedDatasetSchema,
  setReferencedDatasetSchema,
  useFormReturn: { setValue, watch },
}) => {
  const referencedDatasetFieldSchemas = referencedDatasetSchema?.json_schema?.properties;

  const ref_metadata: DatasetReference["ref_metadata"] = watch("ref_metadata");

  return (
    <>
      {referencedDatasetFieldSchemas ? (
        <>
          <Typography variant="h6" className="os-content-description">
            Dataset Retrieval Settings
          </Typography>
          <InputHelpDialogWrapper
            helpTitle="Value Field"
            helpContent="The dataset field to be used as the value of the form input."
          >
            <DropDownFormInput
              schema_field_key="ref_metadata.value_field"
              options={referencedDatasetFieldSchemas}
              onChange={(event) => setValue("ref_metadata", { ...ref_metadata, value_field: event.target.value })}
              getOptionLabel={(fieldSchemaKey) =>
                referencedDatasetFieldSchemas[fieldSchemaKey]?.title ?? fieldSchemaKey
              }
              label="Value Field"
            />
          </InputHelpDialogWrapper>
          <InputHelpDialogWrapper
            helpTitle="Label Field"
            helpContent="The dataset field to be used as the label on the form."
          >
            <DropDownFormInput
              schema_field_key="ref_metadata.label_field"
              options={referencedDatasetFieldSchemas}
              onChange={(event) => setValue("ref_metadata", { ...ref_metadata, label_field: event.target.value })}
              getOptionLabel={(fieldSchemaKey) =>
                referencedDatasetFieldSchemas[fieldSchemaKey]?.title ?? fieldSchemaKey
              }
              label="Label Field"
            />
          </InputHelpDialogWrapper>
        </>
      ) : null}
    </>
  );
};
